import api from './api'

export const emailCustomFieldService = {
  getAllFields: async () => {
    const response = await api.get('/email-custom-fields')
    return response.data
  },

  createField: async (data) => {
    const response = await api.post('/email-custom-fields', data)
    return response.data
  },

  updateField: async (id, data) => {
    const response = await api.put(`/email-custom-fields/${id}`, data)
    return response.data
  },

  deleteField: async (id) => {
    const response = await api.delete(`/email-custom-fields/${id}`)
    return response.data
  }
}
